import {
    BlotterWidgetsState,
    initialBlotterWidgetsState,
    initialBlotterWidgetState,
} from './BlotterWidgetState';
import { BlotterAction, BlotterActionType } from './actions';
import { BlotterComponentsAction } from './components/actions';
import blotterComponentReducer from './components/reducer';

import { blotterConfigReducer } from './configuration/reducer';
import { Reducer } from 'redux';
import {
    BlotterFilteredOrdersActionType,
    BlotterFilteredOrdersAction,
} from './filteredOrders/actions';
import blotterFilteredOrdersReducer from './filteredOrders/reducer';
import { Action } from 'store/store';
import { WidgetActionPayload, WidgetActionType } from 'widgets/store/actions';

export const blotterWidgetsReducer: Reducer<
    BlotterWidgetsState,
    BlotterAction
> = (
    state: BlotterWidgetsState = initialBlotterWidgetsState,
    action: Action<string, Partial<WidgetActionPayload> | undefined>
) => {
    if (action.type === WidgetActionType.WIDGET_RESET_INSTANCES_STATE) {
        return {};
    }

    if (!action.payload || !action.payload.widgetKey) {
        return state;
    }

    const prevWidgetState =
        state[action.payload!.widgetKey] || initialBlotterWidgetState;
    const nextWidgetState = { ...prevWidgetState };

    const reduceState = () => {
        const nextState = { ...state };
        nextState[action.payload!.widgetKey!] = nextWidgetState;
        return nextState;
    };

    switch (action.type) {
        case BlotterActionType.BLOTTER_INITIALISE: {
            return reduceState();
        }
        case BlotterFilteredOrdersActionType.INCREMENT_RESULTS_TICK:
            nextWidgetState.filteredOrders = blotterFilteredOrdersReducer(
                prevWidgetState.filteredOrders,
                action as BlotterFilteredOrdersAction
            );
            return reduceState();
    }

    const nextConfig = blotterConfigReducer(
        prevWidgetState.config,
        action as BlotterComponentsAction
    );

    if (nextConfig !== prevWidgetState.config) {
        nextWidgetState.config = nextConfig;
        return reduceState();
    }

    const nextComponent = blotterComponentReducer(
        prevWidgetState.component,
        action as BlotterComponentsAction
    );

    if (nextComponent !== prevWidgetState.component) {
        nextWidgetState.component = nextComponent;
        return reduceState();
    }

    return state;
};
